import { UtilityText } from '@policygenius/mortar';
import React from 'react';

import Icon from 'components/Icon';

import { INFO_SECURITY_TEXT } from './constants';
import styles from './security-note.module.scss';

const SecurityNote: React.FC = () => (
  <div className={styles.wrapper}>
    <Icon icon="lock" height="16px" width="13px" className={styles.lock} />
    <UtilityText>{INFO_SECURITY_TEXT}</UtilityText>
  </div>
);

export default SecurityNote;
